import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/stylecon.css'
import './assets/css/hxqheam-fonts.css'
import './assets/css/pro-fonts.css'
import './assets/css/tk-fonts.css'
import Validators from './core/util/validators.js'
import './assets/css/reset.css'
import { setCookie, getCookie, delCookie } from './assets/js/auth'
import VueDND from 'awe-dnd'
import $ from 'jquery'
import moment from 'moment'
import layer from "layui-layer";
//引入
import *as echarts  from 'echarts'

Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper');
    var scrollBeforeTop = 0;
    var firstFlag = true;
    selectWrap.addEventListener('scroll', function (e) {
      if (this.scrollTop == scrollBeforeTop) {
        return false;
      }
      let toBtm = sessionStorage.getItem('toBtm');
      if (toBtm == 'true') {
        if (firstFlag) {
          scrollBeforeTop = this.scrollTop;
          firstFlag = false;
          this.scrollTop = 2;
        } else {
          if (this.scrollTop >= scrollBeforeTop) {
            this.scrollTop = 2;
            scrollBeforeTop = this.scrollTop;
          }
        }
      }
      let sign = 1
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
      if (scrollDistance <= sign) {
        sessionStorage.setItem('up2down', 'down');
        binding.value();
        this.scrollTop = 800;
      } else if (this.scrollTop < sign) {
        sessionStorage.setItem('up2down', 'up');
        binding.value();
        this.scrollTop = 2;
      } else {
        return false;
      }
    })
  }
})
// 转到用到的方法      ----   start   ----
//主表带值返回
function bringValue(obj, bringValue, index) {
  let bringVal = bringValue.split(",");
  //带值返回将，当前的弹框中的值，放到上一弹窗的共享值里面
  for (let i = 0; i < bringVal.length; i++) {
    let field = bringVal[i].split("=");
    store.state.shareDetailInfo[index][field[0]] = obj[field[1]];
  }
}
//子表带值返回
function childBringValue(obj, bringValue, index) {
  let bringVal = bringValue.split(",");
  //带值返回将，当前的弹框中的值，放到上一弹窗的共享值里面
  for (let i = 0; i < bringVal.length; i++) {
    let field = bringVal[i].split("=");
    store.state.shareChildDetailInfo[index][field[0]] = obj[field[1]];
  }
}

function putShareValue(frameindex, backdetailInfo) {
  store.state.shareDetailInfo[frameindex] = backdetailInfo;
  console.log(store.state.shareDetailInfo);
}
function putChildShareValue(frameindex, childdetailInfo) {
  store.state.shareChildDetailInfo[frameindex] = childdetailInfo;
  console.log("==============child共享：" + store.state.shareChildDetailInfo);
}

function putNavShareValue(frameindex, name) {
  if (frameindex == 0) {
    store.state.gotoNavigation = [];
  }
  var navlist = store.state.gotoNavigation;
  var navigation = {};
  navigation["name"] = name;
  navigation["frameindex"] = frameindex;
  navlist.push(navigation)
  store.state.gotoNavigation = navlist;
  console.log(store.state.gotoNavigation);
}

window.bringValue = bringValue;
window.putShareValue = putShareValue;
window.putNavShareValue = putNavShareValue;
window.putChildShareValue = putChildShareValue
window.childBringValue = childBringValue;

//  转到用到的方法     ----   end  ----

Vue.use(VueDND)
Vue.use(ElementUI);
Vue.prototype.setCookie = setCookie
Vue.prototype.getCookie = getCookie
Vue.prototype.delCookie = delCookie
Vue.config.productionTip = false
Vue.prototype.Validators = Validators
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts
moment.locale("zh-cn")

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
